/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 934
// module chunks = 2